import axios from "@/axios";

const ordersUrl = process.env.VUE_APP_ORDERS_URL;

export default {
  fetchAll(
    number,
    day,
    kitchenUuid,
    conceptUuid,
    platformUuid,
    country_code,
    summary
  ) {
    let params = {
      number: number,
      day: day,
      kitchen_uuid: kitchenUuid,
      concept_uuid: conceptUuid,
      platform_uuid: platformUuid,
      country_code: country_code,
      summary: summary,
    };
    return axios.get(`${ordersUrl}/orders`, { params: params });
  },
  fetchOne(uuid) {
    return axios.get(`${ordersUrl}/orders/${uuid}`);
  },
  fetchErrorsSummary() {
    return axios.get(`${ordersUrl}/errors-summary`);
  },
  fetchErrors(page, pageSize) {
    var params = "?";
    if (page > 0) {
      params += `page=${page}`;
    }
    if (pageSize > 0) {
      params += `&page_size=${pageSize}`;
    }
    return axios.get(`${ordersUrl}/errors${params}`);
  },
  getErrorContent(path) {
    return axios.post(`${ordersUrl}/errors/get-content`, { path: path });
  },
  deleteError(path) {
    return axios.post(`${ordersUrl}/errors/delete-content`, { path: path });
  },
  retryError(path, topic_name, error_path) {
    return axios.post(`${ordersUrl}/errors/retry-order`, {
      path: path,
      topic_name: topic_name,
      error_path: error_path,
    });
  },
  fetchUncompletedOrders() {
    return axios.get(`${ordersUrl}/orders?completed=false`);
  },
  normalizeOrder(uuid) {
    return axios.post(`${ordersUrl}/orders/${uuid}/normalize`);
  },
  fetchTimeseries(
    kitchenUuid,
    locationUuid,
    conceptUuid,
    startDate,
    endDate,
    startMinute,
    endMinute,
    interval
  ) {
    let params = {
      kitchen_uuid: kitchenUuid,
      location_uuid: locationUuid,
      concept_uuid: conceptUuid,
      start_day: startDate,
      end_day: endDate,
      start_minute: startMinute,
      end_minute: endMinute,
      interval: interval,
    };
    return axios.get(`${ordersUrl}/stats/timeseries`, { params: params });
  },
  fetchPipelineEvents(payload) {
    let {
      status,
      number,
      date,
      platformOrderUuid,
      restaurantPlatformId,
      platform,
    } = payload;
    return axios.get(`${ordersUrl}/pipeline-events`, {
      params: {
        status,
        number,
        date,
        platform,
        platform_order_uuid: platformOrderUuid,
        restaurant_platform_id: restaurantPlatformId,
      },
    });
  },
  getPipelineEvent(eventId) {
    return axios.get(`${ordersUrl}/pipeline-events/${eventId}`);
  },
  retryPipelineEvent(eventId, { retryOptions, order, retryTarget, retryType }) {
    return axios.post(`${ordersUrl}/pipeline-events/${eventId}/retry`, {
      options: retryOptions,
      order: order,
      target: retryTarget,
      type: retryType,
    });
  },
  ignorePipelineEvent(eventId) {
    return axios.post(`${ordersUrl}/pipeline-events/${eventId}/ignore`);
  },
};
